import { webmasterConstants } from '../../constants/webmaster';
import { startSetBalance } from '../../actions/webmaster';

export const setBalance = store => next => action => {
  if (action.type === webmasterConstants.SET_DYNAMIC_DATA) {
    store.dispatch(startSetBalance());

    const balance = setInterval(() => {
      const state = store.getState();

      if (state.webmaster && state.webmaster.isAuthenticated) {
        store.dispatch(startSetBalance());
      } else {
        clearInterval(balance);
      }
    }, 120 * 1000);
  }

  return next(action);
};
